import { render, staticRenderFns } from "./LoanDeductions.vue?vue&type=template&id=ac20adcc&scoped=true"
import script from "./LoanDeductions.vue?vue&type=script&lang=js"
export * from "./LoanDeductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac20adcc",
  null
  
)

export default component.exports